import parse from 'html-react-parser';
import type React from 'react';
import styled from 'styled-components';
import { adjustContentVisibility, Section } from '../Content';
import type { DefaultSectionProps } from '../DefaultSectionProps';
import { ProductCard, ProductsSectionTitle, ProductsSubtitle } from './components';
import type { Product } from './defaults';

export interface ProductsProps extends DefaultSectionProps {
  readonly title: string;
  readonly subtitle?: string;
  readonly products: Product[];
  readonly trackingLabel?: string;
  readonly showDiamond?: boolean;
  cardsWidth?: {
    mobile?: number;
    desktop?: number;
  };
}

const OurProductsList = styled.ul<{ readonly productsQtt: number }>`
  display: flex;
  width: 100%;
  max-width: 1440px;
  align-items: space-between;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 35px;
  gap: 30px;

  @media (max-width: 1430px) {
    max-width: ${({ productsQtt }) => `${productsQtt < 5 ? 1430 : 980}px`};
  }
`;

const StyledSection = styled(Section)`
  ${adjustContentVisibility}
`;

export const Products: React.FC<ProductsProps> = ({
  title,
  subtitle,
  products,
  trackingLabel,
  showDiamond = true,
  cardsWidth,
  ...sectionProps
}) => {
  return (
    <StyledSection {...sectionProps} pb={[50, 80]} pt={[40, 70]}>
      <ProductsSectionTitle tabIndex={0} withSubtitle={subtitle != null}>
        {parse(title)}
      </ProductsSectionTitle>
      {subtitle && <ProductsSubtitle showDiamond={showDiamond}>{subtitle}</ProductsSubtitle>}
      <OurProductsList productsQtt={products.length}>
        {products.map(product => (
          <ProductCard key={product.product} product={product} trackingLabel={trackingLabel} cardsWidth={cardsWidth} />
        ))}
      </OurProductsList>
    </StyledSection>
  );
};
